import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

export default class Hub47ForceOptionSelect extends Component {
    
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener(ThemeEvents.variantUpdate, this.variantUpdate);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener(ThemeEvents.variantUpdate, this.variantUpdate);
    }

    autoSelectUnpickedGroups = () => {
        const fieldsets = document.querySelectorAll('[ref="fieldsets[]"]');
        fieldsets.forEach( fset => {
            const inputs = fset.querySelectorAll('input[type="radio"]');
            let found = false;
            for (const elem of inputs) {
                if (elem.checked && elem.dataset.optionAvailable == 'true') {
                    found = true;
                    break;
                }
            }
            if (!found) {
                for (const elem of inputs) {
                    if (elem.dataset.optionAvailable == 'true') {
                        elem.click();
                        break;
                    }
                }
            }
        });
        clearTimeout(this._timeout);
    }

    variantUpdate = async (event) => {
        this._timeout = setTimeout(this.autoSelectUnpickedGroups, 50);
    }
};

if (!customElements.get('hub47-force-option-select')) {
  customElements.define('hub47-force-option-select', Hub47ForceOptionSelect);
}

